var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-div",style:(("background-image:url(" + _vm.imgUrl + ");height:" + _vm.height + "px;"))},[_c('div',{class:['img-div_content', _vm.className]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }